exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.editor .menu {\n  margin: 20px 0;\n  position: sticky;\n  top: 1rem;\n  z-index: 2;\n  padding: 10px 20px;\n  background-color: white;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2); }\n  .editor .menu a {\n    margin-bottom: 0; }\n  .editor .menu #menu-export {\n    background-color: #ffb700;\n    color: #666;\n    display: inline-block;\n    border-color: transparent; }\n    .editor .menu #menu-export:hover {\n      background-color: transparent;\n      border-color: #ffb700; }\n  @media (max-width: 768px) {\n    .editor .menu a,\n    .editor .menu button {\n      margin-bottom: 10px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/StoryEditor/StoryEditor.scss
// module id = 174
// module chunks = 0